/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue } from 'vue-property-decorator'
import { isUndefined, isNull } from 'lodash/fp'
import LoadingBar from '@core/components/LoadingBar.vue'
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { IProjectInfo } from '@master/config/IProjectInfo'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'

@Component({
  components: {
    LoadingBar
  }
})
export class LoginMixin extends Vue {
  private loginNotice = ''
  private username = ''
  private password = ''
  private disabled = false

  @inject()
  private $api: API

  @inject()
  private projectInfo: IProjectInfo

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  get currentUser () {
    return this.$store.getters.currentUser
  }

  async mounted () {
    console.log('Login page.')
    // When login page is loaded, check if the user is logged in or not
    this.checkLogin()
  }

  async onSubmit () {
    this.disabled = true
    const options = {
      headers:
      {
        'content-type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    }
    const login = await this.$api.account.login({
      accountName: this.username,
      accountPass: this.password
    }, options)
      .then(async response => {
        if (response && response.isLogin) {
          this.loginNotice = 'Login successful, welcome ' + response.accountNames[0]
          return response
        }

        if (response.error) {
          if (response.error.length > 100) {
            console.error('login.js: response error', response.error)
            this.loginNotice = 'Login Exception'
            await this.uiService.alert.show({
              type: 'error',
              message: response.error
            })
          } else {
            console.info('login.js: Failed', response.error)
            this.loginNotice = response.error
          }
        } else {
          console.info('login.js: Failed', response)
          this.loginNotice = 'Login Failed (wrong password?)'
        }
      })
      .catch(async error => {
        console.error('login.js: Exception', error)
        await this.uiService.alert.show({
          type: 'error',
          message: error
        })
      })
      .finally(() => {
        this.disabled = false
      })

    if (!isNull(login) && !isUndefined(login)) {
      const info = await this.getAccountInfo(login.accountID)
      const meta = await this.getAccountMeta(login.accountID)
      await this.$store.dispatch('login', { ...login, ...info, ...meta })

      // After the account info has been retrieved,
      // redirect the user to the page
      this.redirectHome(meta.systemrole)
    }
  }

  async checkLogin () {
    const login = await this.getAccountLogin()

    if (!isNull(login) && !isUndefined(login)) {
      console.log(`Welcome ${login.accountNames[0]}!`)
      const info = await this.getAccountInfo(login.accountID)
      const meta = await this.getAccountMeta(login.accountID)
      await this.$store.dispatch('login', { ...login, ...info, ...meta })

      // After the account info has been retrieved,
      // redirect the user to the page
      this.redirectHome(this.currentUser.systemrole)
    }
  }

  getAccountLogin () {
    return this.$api.account.loginGet()
      .then(response => {
        if (response && response.isLogin) {
          return response
        }
      })
      .catch(async error => {
        console.error('login.js: Exception', error)
        await this.uiService.alert.show({
          type: 'error',
          message: error
        })
      })
  }

  async getAccountInfo (accountId: string) {
    return await this.$api.account.loginInfoGet({
      accountID: accountId
    })
  }

  async getAccountMeta (accountId: string) {
    const response = await this.$api.account.loginMetaGet({
      _oid: accountId
    })
    return response.meta
  }

  redirectHome (role: string): void {
    let page = null
    const redirectPath = this.$router.currentRoute.query.redirect_uri
    if (redirectPath) {
      window.location.href = __BASE_URL__ + redirectPath.toString()
      return
    } else if (role === 'supervisor' || role === 'director') {
      page = 'home-supervisor'
    } else if (role === 'ops-staff') {
      page = 'home-submission'
    } else if (role === 'product-admin') {
      page = 'admin-products'
      window.location.href = __BASE_URL__ + '/admin-products'
    } else if (role === 'bsc-reviewer') {
      page = 'bsc-home'
      window.location.href = __BASE_URL__ + '/bsc-home'
    } else {
      page = 'home-adviser'
    }
    this.$router.push({ name: page })
  }
}
